module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/payrolls/Payroll.ejs -->\n<td>'+
((__t=( model.getPeriodFormatted() ))==null?'':_.escape(__t))+
'</td>\n<td>\n    '+
((__t=( model.getStatusLabel() ))==null?'':_.escape(__t))+
'\n    '+
((__t=( model.get('revertedAt') ? '(Reverted)' : '' ))==null?'':_.escape(__t))+
'\n</td>\n<td>'+
((__t=( model.get('payslips') || 'N/A' ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('grossPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
'</td>\n<td>\n    '+
((__t=( (model.get('mtd') + model.get('cp38'))
        .formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n</td>\n<td>\n    '+
((__t=( (model.get('employeeEpf')
        + model.get('employerEpf'))
        .formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n</td>\n<td>\n    '+
((__t=( (model.get('employeeSocso')
        + model.get('employerSocso'))
        .formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n</td>\n<td>\n    '+
((__t=( moment(model.get('updatedAt'))
        .format('DD/MM/YYYY HH:mm') ))==null?'':_.escape(__t))+
'\n</td>\n<td>\n    ';
 if (model.get('status') === 9) { 
__p+='\n    <a class="btn btn-outine btn-primary\n        js-download" data-file="archive">\n        <i class="fa fa-download"></i>\n        '+
((__t=( archive ? '' : 'Not ready' ))==null?'':_.escape(__t))+
'\n    </a>\n    ';
 } 
__p+='\n</td>\n<td>\n    ';
 if (model.get('status') === 9) { 
__p+='\n    <a class="btn btn-outine btn-primary\n        js-download" data-file="calculations">\n        <i class="fa fa-download"></i>\n        '+
((__t=( calculations ? '' : 'Not ready' ))==null?'':_.escape(__t))+
'\n    </a>\n    ';
 } 
__p+='\n</td>\n<td>\n    ';
 if (model.get('running')) { 
__p+='\n    <button type="button"\n        data-id="'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n        class="btn btn-danger js-unlock">\n        Unlock\n    </button>\n    ';
 } 
__p+='\n\n    ';
 if (!_.contains([3, 9], model.get('status'))) { 
__p+='\n    <button type="button"\n        data-id="'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n        class="btn btn-danger js-cancel">\n        Cancel\n    </button>\n    ';
 } 
__p+='\n\n    ';
 if (model.get('status') === 9) { 
__p+='\n        <button type="button"\n            data-id="'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n            class="btn btn-danger btn-outline js-revert">\n            Revert\n        </button>\n        <button type="button"\n            data-id="'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n            class="btn btn-danger btn-outline js-create-archive">\n            Create Archive\n        </button>\n        <button class="btn btn-outline js-edit">\n            <i class="fa fa-pencil-square-o"></i>\n            Edit Invoice Info\n        </button>\n        ';
 if (
            !model.get('chargebeeInvoiceId') || (
                model.get('chargebeeInvoiceId').substr(0, 2) !== 'MI' &&
                model.get('chargebeeInvoiceId') !== 'free'
            )
        ) { 
__p+='\n            ';
 if (model.get('chargebeeInvoiceId')) { 
__p+='\n                <button \n                    class="btn btn-outline btn-warning js-edit"\n                    data-id="'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n                >\n                    INVOICE: '+
((__t=( model.get('chargebeeInvoiceId') ))==null?'':_.escape(__t))+
'\n                </button>\n            ';
 } 
__p+='\n            ';
 if (model.get('chargebeeAdjustmentInvoiceId')) { 
__p+='\n                <button class="btn btn-outline btn-warning js-edit">\n                    ADJUSTMENT INVOICE: '+
((__t=( model.get('chargebeeAdjustmentInvoiceId') ))==null?'':_.escape(__t))+
'\n                </button>\n            ';
 } 
__p+='\n            <button class="btn btn-outline js-markAsManuallyInvoiced btn-primary"\n                data-id="'+
((__t=( model.id ))==null?'':_.escape(__t))+
'">\n                Mark as Manually Invoiced\n            </button>\n        ';
 } else if (model.get('chargebeeInvoiceId') === 'free') { 
__p+='\n            <button class="btn btn-outline btn-warning disabled" disabled>\n                Free Payroll\n            </button>\n        ';
 } else if (model.get('chargebeeInvoiceId').substr(0, 2) === 'MI') { 
__p+='\n            <button class="btn btn-outline btn-warning disabled" disabled>\n                Manually Invoiced by '+
((__t=( model.get('chargebeeInvoiceId').split('-')[1] ))==null?'':_.escape(__t))+
'\n            </button>\n        ';
 } 
__p+='\n        ';
 if (model.get('chargebeeInvoiceNote')) { 
__p+='\n            <button class="btn btn-outline btn-warning disabled" disabled>\n                '+
((__t=( model.get('chargebeeInvoiceNote') ))==null?'':_.escape(__t))+
'\n            </button>\n        ';
 } 
__p+='\n    ';
 } 
__p+='\n    ';
 disabled = (model.get('status') === 9 && archive) || model.get('status') < 9; 
__p+='\n    <button class="btn btn-outline js-makeArchiveDownloadable\n        '+
((__t=( disabled ? '' : 'btn-primary' ))==null?'':_.escape(__t))+
'"\n        data-id="'+
((__t=( model.id ))==null?'':_.escape(__t))+
'"\n        '+
((__t=( disabled ? 'disabled' : '' ))==null?'':_.escape(__t))+
'>\n        Make File Downloadable\n    </button>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/payrolls/Payroll.ejs
// module id = 663
// module chunks = 1